"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _dishGroupManage = _interopRequireDefault(require("./dishGroupManage.vue"));
var _primaryMenuManage = _interopRequireDefault(require("./primaryMenuManage.vue"));
var _categoryManage = _interopRequireDefault(require("./categoryManage.vue"));
var _SecondCategoryList = _interopRequireDefault(require("./SecondCategoryList.vue"));
var _dishGroupBatch = _interopRequireDefault(require("./dishGroupBatch.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '菜品分组',
  components: {
    DishGroupManage: _dishGroupManage.default,
    PrimaryMenuManage: _primaryMenuManage.default,
    CategoryManage: _categoryManage.default,
    SecondCategoryList: _SecondCategoryList.default,
    DishGroupBatch: _dishGroupBatch.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      activeTab: 'firstCategory',
      selectedParent: null
    };
  },
  methods: {
    handleTabChange: function handleTabChange(value) {
      this.activeTab = value;
      if (value === 'secondCategory') {
        this.selectedParent = null;
      }
    },
    handleShowSecondCategory: function handleShowSecondCategory(parentCategory) {
      this.selectedParent = parentCategory || null;
      this.activeTab = 'secondCategory';
    },
    handleClearParent: function handleClearParent() {
      this.selectedParent = null;
    }
  }
};